import store from '@store/index'
import finance from './finance'
import business from './business'
import myweb from './myweb'

export default {
    path: '',
    component: () => import(/*webpackChunkName: 'manage'*/ '@layout/empty'),
    children: [
        {
            path: 'home',
            redirect: () => {
                return {
                    path: '/zbr/proprietorzbproject/list'
                };

                // return {
                //     path: '/agency/project/list',
                //     query: {
                //         type: 2
                //     }
                // };
            }
        },

        finance,
        business,
        myweb
   
    ]
}